import React from 'react';
import { useTranslation } from 'react-i18next';

import { ImageWrapper, OnboardingCreatorInfoBlock } from 'components';
import { BrandInformationForm } from 'containers/forms';
import { PropTypes } from 'prop-types';
import { ReactComponent as Icon } from '../../assets/img/illustrations/brand-information.svg';

const OnboardingBrandInformationPage = ({ onNext, onLogout }) => {
  const { t } = useTranslation(['pages']);

  return (
    <>
      <h1 className="display-4 text-center">{t('onboarding.brandInfoTitle')}</h1>
      <h4 className="text-muted text-center">{t('onboarding.brandInfoSubtitle')}</h4>
      <ImageWrapper>
        <Icon />
      </ImageWrapper>
      <OnboardingCreatorInfoBlock onLogout={onLogout} />
      <BrandInformationForm
        buttonText={t('brandRegistration.saveAndProceedToTheme')}
        onNext={onNext}
      />
    </>
  );
};

OnboardingBrandInformationPage.propTypes = {
  onNext: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default OnboardingBrandInformationPage;
